import { X, TrendingUp, TrendingDown, AlertTriangle, Target } from "lucide-react";
import MetaProgressBar from "./MetaProgressBar";

const money = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

export default function MetaPopup({ open, onClose, metas, title }) {
  if (!open || !metas || metas.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4">
      <div className="bg-white border-4 border-neutral-900 w-full max-w-2xl max-h-[92vh] overflow-auto shadow-brutal">
        <div className="flex items-center justify-between p-4 border-b-2 border-neutral-900 bg-yellow-400">
          <div className="flex items-center gap-3">
            <Target className="w-6 h-6 text-neutral-950" strokeWidth={2.5} />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-800">
                Status da Meta
              </p>
              <h3 className="font-display font-black text-xl tracking-tight text-neutral-950">
                {title || "Desempenho de Metas"}
              </h3>
            </div>
          </div>
          <button
            data-testid="meta-popup-close"
            onClick={onClose}
            className="p-2 border-2 border-neutral-950 bg-white hover:bg-neutral-950 hover:text-yellow-400"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          {metas.map((m) => {
            const bate = m.bate_meta_tendencia;
            return (
              <div
                key={m.id}
                data-testid={`meta-popup-card-${m.id}`}
                className={`border-4 ${bate ? "border-green-600" : "border-red-600"} p-4`}
              >
                <div className="flex items-center justify-between gap-3 mb-3">
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                      {m.unidade_nome || ""}
                    </p>
                    <h4 className="font-display font-black text-lg">{m.titulo}</h4>
                    <p className="font-mono text-xs text-neutral-600">
                      {new Date(m.periodo_inicio + "T00:00").toLocaleDateString("pt-BR")} →{" "}
                      {new Date(m.periodo_fim + "T00:00").toLocaleDateString("pt-BR")}
                    </p>
                  </div>
                  <div
                    className={`flex items-center gap-2 font-display font-black text-sm uppercase px-3 py-2 ${
                      bate
                        ? "bg-green-600 text-white"
                        : "bg-red-600 text-white animate-pulse"
                    }`}
                  >
                    {bate ? (
                      <>
                        <TrendingUp className="w-4 h-4" /> No ritmo
                      </>
                    ) : (
                      <>
                        <AlertTriangle className="w-4 h-4" /> Abaixo do ritmo
                      </>
                    )}
                  </div>
                </div>

                <MetaProgressBar
                  label="Faturamento"
                  current={m.faturamento_atual}
                  target={m.meta_faturamento}
                  unit=""
                  color={bate ? "bg-green-600" : "bg-red-600"}
                />
                <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs font-mono">
                  <Info label="Atual" value={money(m.faturamento_atual)} />
                  <Info label="Meta" value={money(m.meta_faturamento)} />
                  <Info label="Falta" value={money(m.falta)} accent={bate ? "" : "text-red-700"} />
                  <Info label="Dias restantes" value={m.dias_restantes} />
                </div>

                <div
                  className={`mt-3 p-3 border-2 ${
                    bate ? "border-green-600 bg-green-50" : "border-red-600 bg-red-50"
                  }`}
                >
                  <div className="flex items-start gap-2">
                    {bate ? (
                      <TrendingUp className="w-5 h-5 text-green-700 flex-shrink-0 mt-0.5" />
                    ) : (
                      <TrendingDown className="w-5 h-5 text-red-700 flex-shrink-0 mt-0.5" />
                    )}
                    <div className="text-xs">
                      <div className="font-display font-bold text-sm">
                        {bate
                          ? "Tendência positiva"
                          : "⚠ Atenção: abaixo do necessário"}
                      </div>
                      <div className="text-neutral-700 mt-1">
                        Média diária atual:{" "}
                        <span className="font-bold">{money(m.media_diaria_atual)}</span>.
                        Faturamento necessário/dia para bater meta:{" "}
                        <span className="font-bold">
                          {money(m.faturamento_diario_necessario)}
                        </span>
                        .
                      </div>
                      <div className="text-neutral-700 mt-1">
                        Projeção mantendo ritmo atual:{" "}
                        <span className="font-bold">{money(m.projecao_final)}</span> (
                        {m.meta_faturamento > 0
                          ? ((m.projecao_final / m.meta_faturamento) * 100).toFixed(1)
                          : 0}
                        % da meta)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="p-4 border-t-2 border-neutral-900 flex justify-end">
          <button
            data-testid="meta-popup-ok"
            onClick={onClose}
            className="bg-neutral-950 text-white h-11 px-6 font-display font-bold uppercase text-xs tracking-widest cta-brutal"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
}

function Info({ label, value, accent = "" }) {
  return (
    <div>
      <div className="text-[9px] uppercase tracking-widest text-neutral-500">{label}</div>
      <div className={`font-bold ${accent}`}>{value}</div>
    </div>
  );
}
